import errorImage from '../../../assets/images/error_image.png';
import Image from 'next/image';
import './index.scss';

interface IProps {
  title: string;
  description: string;
}

export default function ErrorLayout({ title, description }: IProps) {
  return (
    <div className="chemical_error_layout">
      <div className="container">
        <div className="row">
          <div className="span12">
            <Image className="img-responsive" src={errorImage} alt={''} />
            <h1 id="main-error">{title}</h1>
            <p id="error-msg">{description}</p>
          </div>
        </div>
        <div className="row">
          <div className="span3">
            <div className="well well-blue-light">
              <h3>North America</h3>

              <p>
                United States: 1 760 603 7200
                <br /> (Toll Free): 1 800 955 6288{' '}
              </p>

              <h3>Europe</h3>

              <p>
                United Kingdom: <br /> +44 (0) 141 814 6100 <br /> (Free phone): +44 (0) 800 269 210{' '}
              </p>

              <h3>Service &amp; Support</h3>

              <p> Have a question or want to speak with a live representative? </p>

              <p>
                <b>US Only: 1 800 955 6288</b>
              </p>
            </div>
          </div>
          <div className="span3">
            <div style={{ height: 10 }}></div>
            <h3>North America</h3>
            <h4>Canada</h4>

            <p>800 263 6236</p>
            <h4>United States</h4>

            <p>800 955 6288</p>

            <h3>South America</h3>
            <h4>Argentina</h4>

            <p>54 11 4556 0844</p>
            <h4>Brasil</h4>

            <p>0800 722 5433</p>
            <h4>Chile</h4>

            <p>56 2 228875500</p>
            <h4>México</h4>

            <p>52 (55) 3098 3800</p>
          </div>
          <div className="span3">
            <div style={{ height: 10 }}></div>
            <h3>Europe</h3>
            <h4>Austria</h4>

            <p>0800 20 10 87</p>
            <h4>Belgium</h4>

            <p>0800 14894</p>
            <h4>Denmark</h4>

            <p>80 30 17 40</p>
            <h4>France</h4>

            <p>0800 23 20 79</p>
            <h4>Germany</h4>

            <p>0800 083 09 02</p>
            <h4>Italy</h4>

            <p>800 872 987</p>
            <h4>Norway</h4>

            <p>00800 5345 5345</p>
            <h4>Netherlands</h4>

            <p>0800 099 3310</p>
            <h4>Portugal</h4>

            <p>800 206 639</p>
            <h4>Spain</h4>

            <p>900 181 461</p>
            <h4>Sweden</h4>

            <p>020 26 34 52</p>
            <h4>Switzerland</h4>

            <p>0800 84 88 00</p>
            <h4>United Kingdom</h4>

            <p>0800 269 210</p>
          </div>
          <div className="span3">
            <div style={{ height: 10 }}></div>
            <h3>Asia Pacific</h3>
            <h4>Australia</h4>

            <p>1800 636 327</p>
            <h4>China (Beijing)</h4>

            <p>800 820 8982</p>
            <h4>China (Guangzhou)</h4>

            <p>86 800 820 8982</p>
            <h4>China (Shanghai)</h4>

            <p>86 800 820 8982</p>
            <h4>China (Hong Kong)</h4>

            <p>852 2407 8450</p>
            <h4>Japan</h4>

            <p>81 3 6832 6980</p>
            <h4>New Zealand</h4>

            <p>0800 636 327</p>
            <h4>Singapore</h4>

            <p>65 6861 8638</p>
            <h4>China (Taiwan)</h4>

            <p>886 2 2358 2838</p>
          </div>
        </div>
      </div>
      <div id="footer" className="text-center">
        <small>
          <div className="legal-text">&copy; 2015 Thermo Fisher Scientific Inc. All Rights Reserved.</div>
        </small>
      </div>
    </div>
  );
}
